const QuickDownloadButton = ({ size = 'large' }) => {
  return (
    <div>
      <svg
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        width={size === 'small' ? '24' : '32'}
        height={size === 'small' ? '24' : '32'}
        className="fill-white stroke-black rounded-full hover:fill-orange-400 hover:stroke-white"
      >
        <circle cx="16" cy="16" r="16" stroke="none" />
        <path fill="none" d="M21.091 15.3636L16.0001 20.4545L10.9092 15.3636" />
        <path fill="none" d="M16 20.4545V9" strokeLinejoin="round" />
        <path fill="none" d="M23 23H9" strokeLinejoin="round" />
      </svg>
    </div>
  );
};

export default QuickDownloadButton;
